// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hinweis-background {
    position: fixed;
    top: 80px;
    left: 0;
    align-self: center;
    width: 100%;
    height: calc(100% - 80px);
    background: rgba(0, 0, 0, 0.3);
    z-index: 999 !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.hinweis-content-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-self: center;
    width: 80%;
    height: fit-content;
    max-height: 80vh;
    background-color: var(--white-base);
    border-radius: 20px;
    
    /* Text Style */
    font-family: 'Poppins', sans-serif;
    font-weight: normal;
    font-size: 16px;
    text-align: left;
    line-height: 1.5;
    margin-bottom: 10px;
}

.hinweis-inner-container{
    margin: 40px 20px 20px 20px;
    overflow-y: scroll;
}

/* Style the scrollbar for Chrome, Safari, and Opera */
.hinweis-inner-container::-webkit-scrollbar {
    width: 12px;
    margin-left: -200px; /* Move scrollbar 20px to the left */
}

.hinweis-inner-container::-webkit-scrollbar-track {
    background: var(--gray-20); /* color of the track */
    border-radius: 10px; /* rounded corners */
}

.hinweis-inner-container::-webkit-scrollbar-thumb {
    background-color: var(--blue-60); /* color of the thumb */
    border-radius: 10px; /* rounded corners */
    border: 2px solid var(--scrollbar-thumb-border-color); /* border around the thumb */
}

.hinweis-toggle-close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 35px;
    height: 35px;
    color: var(--white-base);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    font-size: 24px;
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    text-align: center;
}

.hinweis-title {
    margin: 20px 20px 0px 20px;
    font-size: 28px;
    width: fit-content;
    font-weight: 700;
}

.hinweis-subtitle {
    margin-top: 10px;
    font-weight: 700;
}


.hinweis-text {
    font-size: 16px;
}

ol,
ul {
    font-size: 16px;
    /* Adjust padding left as needed */
}
`, "",{"version":3,"sources":["webpack://./src/widgets/HinweisPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,mBAAmB;;IAEnB,eAAe;IACf,kCAAkC;IAClC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA,sDAAsD;AACtD;IACI,WAAW;IACX,mBAAmB,EAAE,oCAAoC;AAC7D;;AAEA;IACI,0BAA0B,EAAE,uBAAuB;IACnD,mBAAmB,EAAE,oBAAoB;AAC7C;;AAEA;IACI,gCAAgC,EAAE,uBAAuB;IACzD,mBAAmB,EAAE,oBAAoB;IACzC,qDAAqD,EAAE,4BAA4B;AACvF;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,eAAe;IACf,aAAa;IACb,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,kCAAkC;AACtC","sourcesContent":[".hinweis-background {\r\n    position: fixed;\r\n    top: 80px;\r\n    left: 0;\r\n    align-self: center;\r\n    width: 100%;\r\n    height: calc(100% - 80px);\r\n    background: rgba(0, 0, 0, 0.3);\r\n    z-index: 999 !important;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.hinweis-content-container {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-self: center;\r\n    width: 80%;\r\n    height: fit-content;\r\n    max-height: 80vh;\r\n    background-color: var(--white-base);\r\n    border-radius: 20px;\r\n    \r\n    /* Text Style */\r\n    font-family: 'Poppins', sans-serif;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    text-align: left;\r\n    line-height: 1.5;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.hinweis-inner-container{\r\n    margin: 40px 20px 20px 20px;\r\n    overflow-y: scroll;\r\n}\r\n\r\n/* Style the scrollbar for Chrome, Safari, and Opera */\r\n.hinweis-inner-container::-webkit-scrollbar {\r\n    width: 12px;\r\n    margin-left: -200px; /* Move scrollbar 20px to the left */\r\n}\r\n\r\n.hinweis-inner-container::-webkit-scrollbar-track {\r\n    background: var(--gray-20); /* color of the track */\r\n    border-radius: 10px; /* rounded corners */\r\n}\r\n\r\n.hinweis-inner-container::-webkit-scrollbar-thumb {\r\n    background-color: var(--blue-60); /* color of the thumb */\r\n    border-radius: 10px; /* rounded corners */\r\n    border: 2px solid var(--scrollbar-thumb-border-color); /* border around the thumb */\r\n}\r\n\r\n.hinweis-toggle-close-button {\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20px;\r\n    width: 35px;\r\n    height: 35px;\r\n    color: var(--white-base);\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    font-size: 24px;\r\n    display: flex;\r\n    justify-content: center; /* Center horizontally */\r\n    align-items: center; /* Center vertically */\r\n    text-align: center;\r\n}\r\n\r\n.hinweis-title {\r\n    margin: 20px 20px 0px 20px;\r\n    font-size: 28px;\r\n    width: fit-content;\r\n    font-weight: 700;\r\n}\r\n\r\n.hinweis-subtitle {\r\n    margin-top: 10px;\r\n    font-weight: 700;\r\n}\r\n\r\n\r\n.hinweis-text {\r\n    font-size: 16px;\r\n}\r\n\r\nol,\r\nul {\r\n    font-size: 16px;\r\n    /* Adjust padding left as needed */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
